import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import AccountsPage from '@/settings/pages/accounts';

export const Route = createFileRoute('/settings/accounts/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: AccountsRoute,
  staticData: {
    headerSection: null
  }
});

function AccountsRoute() {
  return <AccountsPage/>;
}
